import React, { useState } from 'react';
import { Table, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SubtleBadge from 'components/common/SubtleBadge';
import WarehousePermissionModal from './WarehousePermissionModal';
import { PERMISSION_LABELS } from 'constants/admin/user';

const WarehousePermissionView = ({ permissions = [], permFieldDefs = [] }) => {
  const [modalTarget, setModalTarget] = useState(null);

  if (!permissions.length) {
    return (
      <p className="text-muted mb-0">No warehouse permissions assigned.</p>
    );
  }

  return (
    <>
      <Table responsive striped bordered size="sm" className="mb-0">
        <thead>
          <tr>
            <th>Warehouse</th>
            <th className="text-center">Manager</th>
            {permFieldDefs.map(f => (
              <th key={f.key} className="text-center">
                {f.label}
              </th>
            ))}
            <th className="text-center" style={{ width: '60px' }} />
          </tr>
        </thead>
        <tbody>
          {permissions.map(perm => (
            <tr key={perm.warehouse.id}>
              <td>{perm.warehouse.name}</td>
              <td className="text-center">
                <SubtleBadge
                  pill
                  bg={perm.is_manager ? 'success' : 'secondary'}
                >
                  {perm.is_manager ? 'Yes' : 'No'}
                </SubtleBadge>
              </td>
              {permFieldDefs.map(f => (
                <td key={f.key} className="text-center">
                  {PERMISSION_LABELS[perm[f.key]] ?? perm[f.key] ?? 'None'}
                </td>
              ))}
              <td className="text-center">
                <Button
                  variant="link"
                  size="sm"
                  className="p-0"
                  onClick={() => setModalTarget(perm)}
                >
                  <FontAwesomeIcon icon="eye" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {modalTarget && (
        <WarehousePermissionModal
          show
          onHide={() => setModalTarget(null)}
          warehouse={modalTarget.warehouse}
          permission={modalTarget}
          permFieldDefs={permFieldDefs}
          editing={false}
        />
      )}
    </>
  );
};

export default WarehousePermissionView;
